module.exports = __webpack_public_path__ + "static/media/prevPage.d6ab9845.svg";